/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const frontTypeEnumSchema = z
	.enum(["SBP", "TERMINAL_BASE", "CASH", "YANDEX_BADGE", "PAYMENT_TRACKER"])
	.describe("* `SBP` - QR\n* `TERMINAL_BASE` - Банковская карта\n* `CASH` - Наличные\n* `YANDEX_BADGE` - Яндекс Бейдж\n* `PAYMENT_TRACKER` - Браслет");
